import MD5 from "crypto-js/md5";

export default function () {
	const now = new Date();
	// eslint-disable-next-line func-names
	const sendData = function (data) {
		const nowString = `${now.getUTCFullYear()}-${`0${now.getUTCMonth()}${1}`.slice(
			-2,
		)}-${`0${now.getUTCDay()}`.slice(-2)} ${`0${now.getUTCHours()}`.slice(
			-2,
		)}:${`0${now.getUTCMinutes()}`.slice(-2)}:${`0${now.getUTCSeconds()}`.slice(
			-2,
		)}`;
		const gtmData = {
			var1: navigator.userAgent,
			var5: window.session_key,
			var6: MD5(window.session_key).toString(),
			var9: nowString,
			var10: data.region_md5,
			var11: data.country,
		};
		if (
			document.referrer.indexOf(`${location.protocol}//${location.host}`) < 0
			&& document.referrer != ""
		) {
			gtmData.var2 = document.referrer;
		}
		dataLayer.push(gtmData);
	};

	if (
		localStorage.getItem("geoData") == null
		|| JSON.parse(localStorage.getItem("geoData")).caducity == undefined
		|| JSON.parse(localStorage.getItem("geoData")).caducity
			< Math.floor(now.getTime() / 1000)
		|| JSON.parse(localStorage.getItem("geoData")).version == undefined
		|| JSON.parse(localStorage.getItem("geoData")).version < 3
	) {
		console.log("NEED TO GO OUTSIDE");
		$.getJSON("//geo.juegosjuegos.com/superGeo.php", null, (data) => {
			sendData(data);
			data.caducity = Math.floor(now.getTime() / 1000 + 2592000); // 86400*30*1000 => 30 días en milisegundos
			data.version = 3;
			localStorage.setItem("geoData", JSON.stringify(data));
		});
	} else {
		console.log("FROM STORAGE");
		sendData(JSON.parse(localStorage.getItem("geoData")));
	}
}
